import type { Entity, NamedRegExp } from "shelving";
import { WordRegExp } from "shelving";

/** Format of a hash tag e.g. `#running` */
export type HashTag = `#${string}`;

/** Named groups in a hash tag RegExp. */
export type HashTagData = {
	readonly slug: string;
};

/** Match a hash tag e.g. `#running` */
export const HASH_TAG_REGEXP = new WordRegExp("#(?<slug>[a-zA-Z0-9-_]+)", "g") as NamedRegExp<{ slug: string }>;

/** Username tag, e.g. `@dhoulb` or `@dhoulb/30-day-running-challenge` */
export type AtTag = `@${string}`;

/** Exploded username tag. */
export type AtTagData = {
	readonly username: string; // e.g. `dhoulb`
	readonly slug?: string; // e.g. `30-day-running-challenge`
};

/** Match an at tag e.g. `@dhoulb` or `@dhoulb/30-day-running-challenge` */
export const AT_TAG_REGEXP = new WordRegExp("@(?<username>[a-zA-Z0-9-_]+)(?:\\/(?<slug>[a-zA-Z0-9-_]+))?", "g") as NamedRegExp<AtTagData>;

/** Match a string looking for `profile:{id}` or `challenge:{id}` or `group:{id}` tags to generate a `EntityData` object (but only if it's a complete word). */
export const ENTITY_TAG_REGEXP = new WordRegExp(`(?<entity>[a-z]+:[a-zA-Z0-9-_]+)`, "g") as NamedRegExp<{ entity: Entity }>;
